<template>
  <div class="radio">
    <p :class="[error, 'mb-0']">{{ outerLabel }}</p>
    <p class="error m-0">{{ error }}</p>
    <div class="type-input">
      <div
        :class="[styles, className == 'flex-3' ? 'box flex-3' : 'box']"
        v-for="(option, index) in options"
        :key="index"
      >
        <input
          class="cursor"
          :checked="option.label === value"
          :type="type"
          :name="name"
          :value="option.label"
          @change="$emit('input', $event.target.value)"
          :placeholder="placeholder"
          :id="option.for"
          :disabled="disabled"
        />
        <label class="cursor" :for="option.for">{{ option.label }}</label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Radio",
  props: [
    "placeholder",
    "options",
    "name",
    "value",
    "type",
    "outerLabel",
    "className",
    "error",
    "disabled",
    "styles"
  ]
};
</script>

<style scoped>
label {
  font-weight: 400;
  font-size: var(--fs-body);
  line-height: 1.4;
  color: var(--text);
  font-family: var(--font-sans);
}
.radio p {
  font-weight: 500;
  font-size: var(--fs-sm);
  line-height: 1.4;
  color: var(--muted);
  margin-bottom: 6px;
  margin-top: 0;
  font-family: var(--font-sans);
}
.box {
  flex: 0 0 25%;
  display: flex;
  align-items: center;
  margin-top: 10px;
}
.type-input {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.type-input input[type="radio"] {
  margin-right: 8px;
  accent-color: var(--accent-600);
  cursor: pointer;
}
.flex-3 {
  flex: 0 0 33%;
}
</style>
